import React from 'react';

const ValidationErrorModal = ({ title, message, onClose }) => {
  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: 'rgba(0,0,0,0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1100 // Higher than upload modal
    }}>
      <div style={{
        background: 'white',
        borderRadius: '8px',
        padding: '2rem',
        maxWidth: '500px',
        width: '90%',
        boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
      }}>
        <h2 style={{ marginTop: 0, marginBottom: '1rem', color: '#dc3545' }}>
          {title || 'Validation Error'}
        </h2>
        
        <div style={{ 
          background: '#fee', 
          border: '1px solid #fcc', 
          borderRadius: '4px',
          padding: '1rem',
          marginBottom: '1.5rem'
        }}>
          <p style={{ margin: 0, fontSize: '0.95rem', color: '#721c24', lineHeight: '1.5' }}>
            {message}
          </p>
        </div>

        <div style={{ 
          display: 'flex', 
          gap: '0.5rem', 
          justifyContent: 'flex-end'
        }}>
          <button
            className="btn btn-primary"
            onClick={onClose}
            style={{ padding: '0.75rem 1.5rem' }}
          >
            OK
          </button>
        </div>
      </div>
    </div>
  );
};

export default ValidationErrorModal;
